// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0d65ff74","455":"6275ee17","977":"1613cbbd"}[chunkId] + ".chunk.js";
};